
// To have projects added as cards to the project page, add projects to the list here.
//  1. Set your title, description, and link (unfortunately mandatory for now)
//  2. imgPath must point to an image in src/Assets/images/projects/

const projectList = { "projects" : [
    {
        "title": "Digital Pathology",
        "imgPath": "digital-pathology.png",
        "description": "MLOps and Cloud Development Lead for 7-person Senior Project building and applying containerized deep learning infrastructure for medical diagnoses with AWS, Docker, Python, and PyTorch.",
        "link": "https://github.com/Digital-Pathology"
    },
    {
        "title": "Deep Learning (CS 615)",
        "imgPath": "CS-615.png",
        "description": "Train and compare performance of ANN, MLP, CNN, and GAN neural networks for supervised classification on the CIFAR-10 dataset.",
        "link": "https://github.com/ritik-ghanshani/CIFAR-10-Classifier"
    },
    {
        "title": "Introduction to Software Engineering and Development (SE 181)",
        "imgPath": "software-patterns.png",
        "description": "A Banking system written in Java for Introduction to Software Engineering and Development featuring best practices like testing and build pipelines, 100% testing coverage, and Object Oriented Programming.",
        "link": "https://gitlab.com/ritik-ghanshani/rsg87-ritik-ghanshani-se-181-course-project"
    },
    {
        "title": "Rubiks Cube Solver (CS 380)",
        "imgPath": "rubik.png",
        "description": "An optimized 2x2x2 Rubik's cube solving program that uses variations of BFS, DFS and AStar algorithms to provide a solution in under 0.01 seconds.",
        "link": "https://github.com/ritik-ghanshani/rubiks-cube-solver"
    },
    {
        "title": "Grocery List Referencer (CS 375)",
        "imgPath": "glr.png",
        "description": "A CRUD application that lets the user create Grocery shopping lists and get updates on in store availability of items featuring a React.js front-end and Google Firebase backend.",
        "link": "https://github.com/ritik-ghanshani/GroceryListReferencer"
    },
    {
        "title": "PawNet",
        "imgPath": "pawnet.png",
        "description": "A Flutter based cross platform mobile application that provides a Tinder like interface for pet adopters to match with pets available for adoption.",
        "link": "https://github.com/ritik-ghanshani/GroceryListReferencer"
    }
]}

export default projectList;